import type { PackageRecord } from "../types";

type ServiceTypeOption = {
  code: string;
  name: string;
};

const sequenceSuffix = /\s*·\s*#?\d+\.\s*paket$/iu;

export function packageServiceName(
  record: PackageRecord,
  serviceTypes: ServiceTypeOption[] = []
) {
  const canonicalName = serviceTypes.find(
    (service) => service.code === record.serviceTypeCode
  )?.name;

  if (canonicalName) return canonicalName;

  const withoutSequence = record.detail.replace(sequenceSuffix, "").trim();
  const sessionSuffix = `-${record.quantity}`;
  return withoutSequence.endsWith(sessionSuffix)
    ? withoutSequence.slice(0, -sessionSuffix.length).trim()
    : withoutSequence;
}

export function packageSequenceNumber(
  record: PackageRecord,
  allRecords: PackageRecord[]
) {
  if (record.servicePackageSequence && record.servicePackageSequence > 0) {
    return record.servicePackageSequence;
  }

  const matchingRecords = allRecords
    .filter((candidate) => {
      if (candidate.customerId !== record.customerId) return false;
      if (record.serviceTypeCode && candidate.serviceTypeCode) {
        return candidate.serviceTypeCode === record.serviceTypeCode;
      }
      return packageServiceName(candidate) === packageServiceName(record);
    })
    .sort((left, right) =>
      `${left.registrationDate}|${left.id}`.localeCompare(
        `${right.registrationDate}|${right.id}`
      )
    );

  const position = matchingRecords.findIndex((candidate) => candidate.id === record.id);
  return position >= 0 ? position + 1 : undefined;
}

export function packageIdentity(
  record: PackageRecord,
  allRecords: PackageRecord[],
  serviceTypes: ServiceTypeOption[] = []
) {
  const serviceName = packageServiceName(record, serviceTypes);
  const sequence = packageSequenceNumber(record, allRecords);
  return {
    serviceName,
    sequence,
    label: sequence ? `${serviceName} · ${sequence}. paket` : serviceName
  };
}
